// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* colour tokens — also on the standalone Filters button (CustomFilterButton in a page header) */
.cat-wrap,
.cat-filterBtnStandalone {
  --cat-accent: var(--cui-primary);
  --cat-accent-soft: var(--cui-primary-soft);
  --cat-accent-dark: var(--cui-primary-hover);
  --cat-ink: var(--cui-text);
  --cat-ink-soft: #56617a;
  --cat-ink-faint: #94a1b8;
  --cat-border: var(--cui-border-soft);
  --cat-surface: var(--cui-bg);
  --cat-surface-soft: var(--cui-bg-subtle);
  --cat-danger: var(--cui-danger);
  --cat-danger-soft: var(--cui-danger-soft);
  --cat-success: #12805c;
  --cat-success-soft: #e5f6ee;
  --cat-warning: #a15c00;
  --cat-warning-soft: #fdf1de;
}

.cat-wrap {
  display: flex;
  flex-direction: column;
  max-height: var(--cat-max-height, 70vh);
  background: var(--cat-surface);
  border: 1px solid var(--cat-border);
  border-radius: 14px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 6px 16px -8px rgba(15, 23, 42, 0.08);
  overflow: hidden;
}

.cat-wrap * {
  box-sizing: border-box;
}

/* ==========================================================
   TOOLBAR — 3 zones: title (left) / search+filters (center) /
   primary actions (right). Grid so the center zone can genuinely
   center itself instead of just sitting in leftover flex space.
   ========================================================== */

/*
 * Wrapping flex layout (not a fixed grid): on wide screens the three zones sit on one row;
 * as space runs out they wrap onto new rows instead of overflowing. See RESPONSIVE below.
 */
.cat-toolbar {
  flex-shrink: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px 12px;
  padding: 12px 16px;
  border-bottom: 1px solid var(--cat-border);
  background: var(--cat-surface);
}

.cat-toolbarLeft {
  display: flex;
  align-items: center;
  flex: 1 1 180px; /* grows, but gives way to search + actions */
  min-width: 0;
}

.cat-title {
  font-size: 14.5px;
  font-weight: 700;
  color: var(--cat-ink);
  margin: 0;
  line-height: 1.35;
  min-width: 0;
  overflow-wrap: anywhere; /* long titles wrap instead of pushing the toolbar wider */
}

.cat-toolbarCenter {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  flex-wrap: wrap;
  flex: 1 1 240px;
  min-width: 0;
}

.cat-toolbarCenter:empty {
  display: none;
}

.cat-toolbarRight {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap; /* buttons, badges and dropdowns wrap instead of running off the edge */
  gap: 8px;
  flex: 0 1 auto;
  min-width: 0;
  max-width: 100%;
  margin-left: auto;
}

/* ---------- premium search ---------- */

.cat-search {
  position: relative;
  flex: 1 1 220px;
  min-width: 180px;
  max-width: 420px;
}

.cat-searchIcon {
  position: absolute;
  left: 11px;
  top: 50%;
  transform: translateY(-50%);
  width: 14px;
  height: 14px;
  color: var(--cat-ink-faint);
  pointer-events: none;
}

.cat-searchInput {
  width: 100%;
  height: var(--cui-control-height); /* same height as toolbar buttons */
  padding: 0 32px;
  font-size: var(--cui-font-size);
  border: var(--cui-border-width) solid var(--cat-border);
  border-radius: var(--cui-radius);
  outline: none;
  background: var(--cat-surface-soft);
  color: var(--cat-ink);
  transition: border-color 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;
}

.cat-searchInput::placeholder {
  color: var(--cat-ink-faint);
}

.cat-searchInput:focus {
  border-color: var(--cat-accent);
  background: var(--cat-surface);
  box-shadow: 0 0 0 3px var(--cui-primary-ring);
}

.cat-searchClear,
.cat-searchSpinner {
  position: absolute;
  right: 9px;
  top: 50%;
  transform: translateY(-50%);
}

.cat-searchClear {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border: none;
  border-radius: 50%;
  background: var(--cat-border);
  color: var(--cat-ink-soft);
  cursor: pointer;
  padding: 0;
}

.cat-searchClear:hover {
  background: #d7dce6;
}

.cat-searchSpinner {
  width: 14px;
  height: 14px;
  color: var(--cat-accent);
  animation: cat-spin 0.8s linear infinite;
}

.cat-filters {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.cat-toolbarActions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
  min-width: 0;
  max-width: 100%;
}

/* page-supplied controls (dropdown wrappers, buttons, badges) never exceed the toolbar */
.cat-toolbarActions > * {
  max-width: 100%;
  min-width: 0;
}

/* ---------- refresh / export toolbar buttons ---------- */

.cat-refreshBtn {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: var(--cui-control-height);   /* square, same height as the other buttons */
  height: var(--cui-control-height);
  border-radius: var(--cui-radius);
  border: var(--cui-border-width) solid var(--cat-border);
  background: var(--cat-surface);
  color: var(--cat-ink-soft);
  cursor: pointer;
  transition: background 0.12s ease, color 0.12s ease, border-color 0.12s ease;
}

.cat-refreshBtn:hover:not(:disabled) {
  background: var(--cat-accent-soft);
  color: var(--cat-accent);
  border-color: #c7d2ff;
}

.cat-refreshBtn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.cat-spinning {
  animation: cat-spin 0.8s linear infinite;
}

.cat-exportBtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  min-height: var(--cui-control-height); /* = CustomButton md */
  padding: 8px 16px;
  font-size: 13.5px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  border-radius: var(--cui-radius);
  border: var(--cui-border-width) solid var(--cat-border);
  background: var(--cat-surface);
  color: var(--cat-ink-soft);
  cursor: pointer;
  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;
}

.cat-exportBtn:hover {
  background: var(--cat-accent-soft);
  color: var(--cat-accent);
  border-color: #c7d2ff;
}

/* ---------- inline "loading..." label next to search/filters ---------- */

.cat-loadingLabel {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: var(--cat-ink-faint);
}

.cat-loadingLabelSpinner {
  width: 13px;
  height: 13px;
  animation: cat-spin 0.8s linear infinite;
}

/* ==========================================================
   SCROLL REGION
   ========================================================== */

/* Wrapper holds the scroll area + the ◀ ▶ ↑ buttons, which must NOT
   scroll with the content, so they live outside .cat-scroll. */
.cat-scrollWrap {
  position: relative;
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-height: 0;
}

.cat-scroll {
  position: relative;
  flex: 1 1 auto;
  min-height: 0;
  overflow: auto;
  overscroll-behavior-x: contain;
  /* Firefox */
  scrollbar-width: thin;
  scrollbar-color: #c3c8d4 transparent;
}

/* ---------- slim rounded scrollbars (Chrome / Edge / Safari) ---------- */
.cat-scroll::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

.cat-scroll::-webkit-scrollbar-track {
  background: var(--cat-surface-soft);
}

.cat-scroll::-webkit-scrollbar-thumb {
  border: 2px solid var(--cat-surface-soft);
  border-radius: 999px;
  background: #c3c8d4;
}

.cat-scroll::-webkit-scrollbar-thumb:hover {
  background: var(--cat-accent);
}

.cat-scroll::-webkit-scrollbar-corner {
  background: var(--cat-surface-soft);
}

/* ---------- edge fades: show there's more content sideways ---------- */
.cat-scrollWrap::before,
.cat-scrollWrap::after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 10px; /* stop above the horizontal scrollbar */
  z-index: 4;
  width: 32px;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.cat-scrollWrap::before {
  left: 0;
  background: linear-gradient(to right, rgba(15, 23, 42, 0.08), transparent);
}

.cat-scrollWrap::after {
  right: var(--cat-sticky-right, 0px);
  background: linear-gradient(to left, rgba(15, 23, 42, 0.08), transparent);
}

.cat-canLeft::before,
.cat-canRight::after {
  opacity: 1;
}

/* ---------- ◀ ▶ ↑ buttons ---------- */
.cat-scrollBtn {
  position: absolute;
  z-index: 6;
  display: grid;
  place-items: center;
  width: 36px;
  height: 36px;
  padding: 0;
  border: 1px solid var(--cat-border);
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.96);
  color: var(--cat-ink);
  box-shadow: 0 6px 18px -6px rgba(15, 23, 42, 0.35);
  cursor: pointer;
  backdrop-filter: blur(4px);
  animation: cat-scrollBtnIn 0.15s ease both;
  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease,
    transform 0.15s ease;
}

.cat-scrollBtn:hover {
  border-color: var(--cat-accent);
  background: var(--cat-accent);
  color: #fff;
}

.cat-scrollBtn:active {
  transform: scale(0.94);
}

.cat-scrollBtn:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px var(--cui-primary-ring);
}

/* Vertically centred on the body (below the sticky header) */
.cat-scrollBtn-left,
.cat-scrollBtn-right {
  top: calc(50% + var(--cat-header-h, 48px) / 2);
  transform: translateY(-50%);
}

.cat-scrollBtn-left:active,
.cat-scrollBtn-right:active {
  transform: translateY(-50%) scale(0.94);
}

.cat-scrollBtn-left {
  left: 10px;
}

/* Sits just left of the sticky Actions column so it never covers a button */
.cat-scrollBtn-right {
  right: calc(var(--cat-sticky-right, 0px) + 10px);
}

.cat-scrollBtn-top {
  right: calc(var(--cat-sticky-right, 0px) + 14px);
  bottom: 20px;
  border-color: transparent;
  background: var(--cat-accent);
  color: #fff;
}

.cat-scrollBtn-top:hover {
  background: var(--cat-accent-dark);
}

@keyframes cat-scrollBtnIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

/* Phones: swipe works, so keep the buttons smaller */
@media (max-width: 576px) {
  .cat-scrollBtn {
    width: 30px;
    height: 30px;
  }

  .cat-scrollBtn-left { left: 6px; }
  .cat-scrollBtn-right { right: calc(var(--cat-sticky-right, 0px) + 6px); }
}

@media (prefers-reduced-motion: reduce) {
  .cat-scrollBtn { animation: none; }
}

.cat-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 13px;
}

.cat-dense .cat-table {
  font-size: 12.5px;
}

/* ---------- header: height driven by rowHeight preset, sticky by default ---------- */

.cat-table thead th {
  position: sticky;
  top: 0;
  z-index: 2;
  height: var(--cat-header-h, 48px);
  background: var(--cat-surface-soft);
  color: var(--cat-ink-soft);
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  padding: 0 14px;
  border-bottom: 1px solid var(--cat-border);
  white-space: nowrap;
  text-align: left;
}

/* grouped header (columns with \`group\`): merged group cell on row 1, its columns on row 2 */
.cat-table thead th.cat-thGroup {
  text-align: center;
  border-left: 1px solid var(--cat-border);
  border-right: 1px solid var(--cat-border);
}

.cat-table thead tr.cat-thSubRow th {
  top: var(--cat-header-h, 48px); /* pins just under row 1 */
  font-size: 10px;
}

/* stickyHeader={false} — header scrolls away with the body instead of pinning */
.cat-headerStatic .cat-table thead th {
  position: static;
}

.cat-dense .cat-table thead th {
  padding: 0 12px;
}

.cat-thContent {
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.cat-thSortable {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.cat-thSortable:hover {
  color: var(--cat-ink);
}

.cat-sortIcon {
  width: 13px;
  height: 13px;
  flex-shrink: 0;
}

.cat-sortIcon-idle {
  color: #c3c8d4;
}

.cat-sortIcon-active {
  color: var(--cat-accent);
}

/* ---------- rows: height driven by rowHeight preset ---------- */

.cat-table tbody td {
  height: var(--cat-row-h, 52px);
  padding: 0 14px;
  color: var(--cat-ink);
  border-bottom: 1px solid #eef0f5;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 320px;
  vertical-align: middle;
}

.cat-dense .cat-table tbody td {
  padding: 0 12px;
}

.cat-tdWrap {
  white-space: normal;
  text-overflow: clip;
  height: auto;
  padding-top: 10px;
  padding-bottom: 10px;
}

.cat-table tbody tr:last-child td {
  border-bottom: none;
}

.cat-table tbody tr:nth-child(even) td {
  background: #fbfcfe;
}

.cat-table tbody tr:hover td {
  background: var(--cat-accent-soft);
}

.cat-rowClickable {
  cursor: pointer;
}

.cat-rowSelected td {
  background: var(--cat-accent-soft) !important;
}

/* subtotal / grand-total rows (rowClassName) */
.cat-rowTotal td {
  font-weight: 700;
  background: var(--cat-surface-soft);
}
.cat-rowGrandTotal td {
  font-weight: 700;
  background: var(--cat-accent-soft);
  color: var(--cat-accent-dark);
}

/* ---------- selection + serial columns ---------- */

.cat-selectCol,
.cat-serialCol {
  width: 1%;
  white-space: nowrap;
  text-align: center;
  color: var(--cat-ink-faint);
  font-variant-numeric: tabular-nums;
}

.cat-selectCol input[type="checkbox"],
.cat-serialCol {
  accent-color: var(--cat-accent);
}

.cat-selectCol input[type="checkbox"] {
  width: 15px;
  height: 15px;
  cursor: pointer;
}

/* ---------- sticky right-hand actions column ---------- */

.cat-actionsCol,
.cat-actionsCell {
  text-align: right;
}

.cat-sticky {
  position: sticky;
  right: 0;
  z-index: 1;
  background: var(--cat-surface);
  transition: box-shadow 0.15s ease;
}

th.cat-sticky {
  z-index: 3;
  background: var(--cat-surface-soft);
}

.cat-table tbody tr:nth-child(even) td.cat-sticky {
  background: #fbfcfe;
}

.cat-table tbody tr:hover td.cat-sticky,
.cat-rowSelected td.cat-sticky {
  background: var(--cat-accent-soft) !important;
}

/* Shadow only appears once the table has actually been scrolled
   horizontally — otherwise a static shadow on an unscrolled table
   just looks like a stray visual artifact. */
.cat-scrolledX .cat-sticky {
  box-shadow: -8px 0 12px -6px rgba(15, 23, 42, 0.14);
}

.cat-actionsRow {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
  white-space: nowrap;
}

/* ---------- circular icon action buttons ---------- */

.cat-iconBtn {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 1px solid transparent;
  background: transparent;
  color: var(--cat-ink-soft);
  cursor: pointer;
  transition: background 0.12s ease, color 0.12s ease, border-color 0.12s ease;
}

.cat-iconBtn-view:hover {
  background: var(--cat-accent-soft);
  color: var(--cat-accent);
}

.cat-iconBtn-edit:hover {
  background: var(--cat-warning-soft);
  color: var(--cat-warning);
}

.cat-iconBtn-delete:hover {
  background: var(--cat-danger-soft);
  color: var(--cat-danger);
}

/* Lightweight CSS-only tooltip via data-tooltip, no extra JS/deps */
.cat-iconBtn::after {
  content: attr(data-tooltip);
  position: absolute;
  bottom: calc(100% + 6px);
  left: 50%;
  transform: translateX(-50%) translateY(2px);
  background: var(--cat-ink);
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  padding: 4px 8px;
  border-radius: 6px;
  white-space: nowrap;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.12s ease, transform 0.12s ease;
  z-index: 5;
}

.cat-iconBtn:hover::after {
  opacity: 1;
  transform: translateX(-50%) translateY(0);
}
.cat-portalTooltip {
  position: fixed;
  transform: translate(-50%, -100%);
  background: #0f172a;
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  padding: 4px 8px;
  border-radius: 6px;
  white-space: nowrap;
  pointer-events: none;
  z-index: 1000;
  animation: cat-tooltipPop 0.1s ease both;
}

@keyframes cat-tooltipPop {
  from {
    opacity: 0;
    transform: translate(-50%, -96%);
  }
  to {
    opacity: 1;
    transform: translate(-50%, -100%);
  }
}
/* ---------- status badges ---------- */

.cat-statusBadge {
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  font-size: 11px;
  font-weight: 700;
  border-radius: 999px;
  white-space: nowrap;
}

.cat-status-active {
  background: var(--cat-success-soft);
  color: var(--cat-success);
}

.cat-status-approved {
  background: var(--cat-accent-soft);
  color: var(--cat-accent);
}

.cat-status-pending {
  background: var(--cat-warning-soft);
  color: var(--cat-warning);
}

.cat-status-inactive {
  background: #f1f2f6;
  color: var(--cat-ink-soft);
}

.cat-status-rejected {
  background: var(--cat-danger-soft);
  color: var(--cat-danger);
}

.cat-status-default {
  background: #f1f2f6;
  color: var(--cat-ink-soft);
}

/* ==========================================================
   SKELETON LOADING
   ========================================================== */

.cat-skeletonRow td {
  padding: 0 14px;
}

.cat-skeletonBar {
  display: block;
  height: 11px;
  width: 80%;
  border-radius: 6px;
  background: linear-gradient(90deg, #eef0f5 25%, #f7f8fb 37%, #eef0f5 63%);
  background-size: 400% 100%;
  animation: cat-shimmer 1.4s ease infinite;
}

@keyframes cat-shimmer {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}

/* ==========================================================
   REFETCH OVERLAY
   ========================================================== */

.cat-loadingOverlay {
  position: sticky;
  left: 0;
  bottom: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px;
  background: rgba(255, 255, 255, 0.72);
  backdrop-filter: blur(1px);
  pointer-events: none;
}

.cat-loadingOverlayText {
  font-size: 12px;
  font-weight: 600;
  color: var(--cat-ink-soft);
}

.cat-loadingSpinner {
  width: 18px;
  height: 18px;
  color: var(--cat-accent);
  animation: cat-spin 0.8s linear infinite;
}

@keyframes cat-spin {
  to {
    transform: rotate(360deg);
  }
}

/* ==========================================================
   EMPTY STATE
   ========================================================== */

.cat-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 44px 20px;
  color: var(--cat-ink-soft);
}

.cat-emptyIcon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: var(--cat-surface-soft);
  color: var(--cat-ink-faint);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
}

.cat-emptyTitle {
  font-size: 13.5px;
  font-weight: 700;
  color: var(--cat-ink);
  margin-bottom: 4px;
}

.cat-emptyDesc {
  font-size: 12px;
  color: var(--cat-ink-faint);
  max-width: 280px;
}

/* ==========================================================
   FOOTER / PAGINATION
   ========================================================== */

.cat-footer {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding: 9px 16px;
  border-top: 1px solid var(--cat-border);
  background: var(--cat-surface);
}

.cat-footerInfo {
  font-size: 12px;
  color: var(--cat-ink-soft);
  white-space: nowrap;
}

.cat-footerControls {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.cat-pageSize {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: var(--cat-ink-soft);
}

.cat-pageSize select {
  padding: 4px 7px;
  font-size: 12.5px;
  border: 1px solid var(--cat-border);
  border-radius: 6px;
  background: var(--cat-surface);
  outline: none;
  cursor: pointer;
}

.cat-pageSize select:focus {
  border-color: var(--cat-accent);
}

.cat-pager {
  display: flex;
  align-items: center;
  gap: 4px;
}

.cat-pageBtn {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 27px;
  height: 27px;
  padding: 0 6px;
  font-size: 12.5px;
  font-weight: 600;
  color: var(--cat-ink-soft);
  background: var(--cat-surface);
  border: 1px solid var(--cat-border);
  border-radius: 7px;
  cursor: pointer;
  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;
}

/* explicit colours so global button / .btn hover styles can't wash the number out */
.cat-pager .cat-pageBtn:hover:not(:disabled),
.cat-pager .cat-pageBtn:focus-visible {
  background: var(--cat-accent-soft, #eef1ff);
  border-color: var(--cat-accent, #4f5fe8);
  color: var(--cat-accent, #4f5fe8);
  opacity: 1;
}

.cat-pageBtn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.cat-pager .cat-pageBtn-active,
.cat-pager .cat-pageBtn-active:hover:not(:disabled),
.cat-pager .cat-pageBtn-active:focus-visible {
  background: var(--cat-accent, #4f5fe8);
  border-color: var(--cat-accent, #4f5fe8);
  color: #fff;
}

.cat-pageEllipsis {
  padding: 0 4px;
  color: var(--cat-ink-faint);
  font-size: 12.5px;
}

/* ==========================================================
   RESPONSIVE
   ========================================================== */

/*
 * Laptops + tablets: title on its own row. The center wrapper dissolves
 * (display: contents) so search and page filters (status dropdown, etc.) sit
 * on the same row as the button group, all vertically centred. When space runs
 * out the button group drops to its own row, still right-aligned and together.
 */
@media (max-width: 1199.98px) {
  .cat-toolbarLeft {
    flex-basis: 100%;
  }
  .cat-toolbarCenter {
    display: contents;
  }
  .cat-search {
    flex: 1 1 240px;
    max-width: none;
  }
  .cat-filters {
    flex: 0 1 auto;
    min-width: 0;
  }
  .cat-toolbarRight {
    flex: 1 1 auto;
    margin-left: 0;
  }
}

@media (max-width: 767.98px) {
  .cat-toolbar {
    padding: 12px;
  }
}

/*
 * Phones: search gets the full row; page filters (status dropdown, etc.) and
 * the Filters / Export buttons share the next row; toolbar actions (badges,
 * extra buttons) fill the last row.
 */
@media (max-width: 575.98px) {
  .cat-toolbar {
    padding: 10px;
    gap: 8px;
  }
  .cat-title {
    font-size: 14px;
  }
  .cat-search {
    min-width: 0;
    flex: 1 1 100%;
  }
  .cat-filters {
    flex: 1 1 170px;
  }
  .cat-filters > * {
    flex: 1 1 150px;
    min-width: 0 !important; /* dropdown wrappers carry an inline min-width */
  }
  .cat-toolbarRight {
    flex: 1 1 100%;
  }
  .cat-exportBtn,
  .cat-filterBtn {
    flex: 1 1 auto;
  }
  .cat-toolbarActions {
    flex: 1 1 100%;
  }
  .cat-toolbarActions > * {
    flex: 1 1 auto;
    justify-content: center;
    min-width: 0 !important;
  }
}

@media (max-width: 640px) {
  .cat-footer {
    flex-direction: column;
    align-items: stretch;
  }
  .cat-footerControls {
    justify-content: space-between;
  }
}

/* ==========================================================
   DELETE CONFIRMATION DIALOG (used when deleteDialog=true)
   ========================================================== */

.cat-confirmOverlay {
  position: fixed;
  inset: 0;
  z-index: 3000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(15, 23, 42, 0.5);
  backdrop-filter: blur(2px);
  animation: cat-confirmFade 0.15s ease both;
}

.cat-confirmCard {
  width: 100%;
  max-width: 380px;
  background: #fff;
  border-radius: 16px;
  padding: 24px;
  text-align: center;  
  box-shadow:
    0 24px 60px -12px rgba(15, 23, 42, 0.4),
    0 0 0 1px rgba(15, 23, 42, 0.04);
  animation: cat-confirmPop 0.18s cubic-bezier(0.34, 1.56, 0.64, 1) both;
}

.cat-confirmIcon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: #fdeceb;
  color: #c0273f;
  display: flex;
  align-items: center;
  justify-content: center;
   margin: 0 auto 14px; 
}

.cat-confirmBody {
  margin-bottom: 20px;
}

.cat-confirmTitle {
  font-size: 15.5px;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 6px;
}

.cat-confirmMessage {
  font-size: 13.5px;
  color: #64748b;
  line-height: 1.55;
  margin: 0;
}

.cat-confirmActions {
  display: flex;
  justify-content: center;
  gap: 32px;
}

.cat-confirmBtn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 600;
  border-radius: 9px;
  border: 1px solid transparent;
  cursor: pointer;
  transition:
    background 0.12s ease,
    border-color 0.12s ease,
    transform 0.08s ease;
}

.cat-confirmBtn:active {
  transform: scale(0.97);
}

.cat-confirmBtn-cancel {
  background: #f3f5f9;
  color: #475569;
  border-color: #e5e9f0;
}

.cat-confirmBtn-cancel:hover {
  background: #e6e9f0;
}

.cat-confirmBtn-danger {
  background: #dc2f4c;
  color: #fff;
  box-shadow: 0 6px 16px -4px rgba(220, 47, 76, 0.5);
}

.cat-confirmBtn-danger:hover {
  background: #c0273f;
}

@keyframes cat-confirmFade {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes cat-confirmPop {
  from {
    opacity: 0;
    transform: translateY(8px) scale(0.96);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* ==========================================================
   FILTER BUTTON (opens the advanced-filter drawer)
   ========================================================== */

.cat-filterBtn {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  min-height: var(--cui-control-height); /* = CustomButton md */
  padding: 8px 16px;
  font-size: 13.5px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  border-radius: var(--cui-radius);
  border: var(--cui-border-width) solid var(--cat-border);
  background: var(--cat-surface);
  color: var(--cat-ink-soft);
  cursor: pointer;
  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;
}

.cat-filterBtn:hover {
  background: var(--cat-accent-soft);
  color: var(--cat-accent);
  border-color: #c7d2ff;
}

.cat-filterBtn-active {
  background: var(--cat-accent-soft);
  border-color: var(--cat-accent);
  color: var(--cat-accent);
}

/* in a page header (PageTitle) App.css turns every \`.Title span\` into a 180px block on phones — not this badge */
.Title .cat-filterBtnStandalone .cat-filterBadge {
  display: inline-flex;
  max-width: none;
  overflow: visible;
}
.Title .cat-filterBtnStandalone {
  flex: 0 0 auto;
}

.cat-filterBadge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  border-radius: 999px;
  background: var(--cat-accent);
  color: #fff;
  font-size: 11px;
  font-weight: 700;
}

/* ==========================================================
   ADVANCED FILTER DRAWER
   Structure mirrors the table itself: fixed header, scrolling
   body, fixed footer — so Search never scrolls out of reach no
   matter how many fields are configured.
   ========================================================== */

.cat-drawerOverlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100vh;
  z-index: 4000;
  background: rgba(15, 23, 42, 0);
  pointer-events: none;
  transition: background 0.2s ease;
}

.cat-drawerOverlay-open {
  background: rgba(15, 23, 42, 0.4);
  pointer-events: auto;
}

.cat-drawer {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  height: 100vh;
  height: 100dvh; /* modern browsers: accounts for mobile browser chrome */
  width: 420px;
  max-width: 90vw;
  background: #fff;
  box-shadow: -12px 0 32px -12px rgba(15, 23, 42, 0.3);
  display: flex;
  flex-direction: column;
  transform: translateX(100%);
  transition: transform 0.22s ease;
}

.cat-drawer-open {
  transform: translateX(0);
}
.cat-drawerHeader {
  position: relative;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 18px 18px 16px;
  /* soft brand tint fading into white */
  background:
    radial-gradient(120% 140% at 0% 0%, rgba(79, 95, 232, 0.12) 0%, transparent 60%),
    linear-gradient(180deg, #f7f8ff 0%, #ffffff 100%);
  border-bottom: 1px solid var(--cat-border);
}


.cat-drawerHeader::after {
  content: "";

  position: absolute;
  left: 0;
  bottom: -1px;

  width: 100%;
  height: 1px;

  background: linear-gradient(
    90deg,
    transparent,
    var(--cui-primary-border),
    transparent
  );
}


/* title wrapper */
.cat-drawerTitleWrap {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}


.cat-drawerTitleIcon {
  display: grid;
  place-items: center;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  border-radius: 12px;
  background: linear-gradient(135deg, var(--cui-primary) 0%, var(--cui-primary-light) 100%);
  color: #fff;
  box-shadow:
    0 8px 18px -8px rgba(79, 95, 232, 0.75),
    inset 0 1px 0 rgba(255, 255, 255, 0.25);
}


.cat-drawerHeader h4 {
  margin: 0;

  font-size: 15px;
  font-weight: 750;

  color: #0f172a;

  letter-spacing: -0.01em;
}


.cat-drawerSubtitle {
  margin-top: 3px;
  overflow: hidden;
  color: var(--cui-text-muted);
  font-size: 12px;
  line-height: 1.4;
  text-overflow: ellipsis;
}


/* close button */

.cat-drawerClose {
  display: grid;
  place-items: center;
  width: 34px;
  height: 34px;
  flex-shrink: 0;
  padding: 0;
  border: 1px solid var(--cat-border);
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.9);
  color: var(--cui-text-muted);
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease,
    transform 0.15s ease;
}

.cat-drawerClose:hover {
  border-color: var(--cui-danger-border);
  background: var(--cui-danger-soft);
  color: var(--cui-danger);
  transform: rotate(90deg);
}

.cat-drawerClose:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px var(--cui-primary-ring);
}

/* title + live "n selected" pill */
.cat-drawerTitleText {
  min-width: 0;
}

.cat-drawerTitleRow {
  display: flex;
  align-items: center;
  gap: 8px;
}

.cat-drawerCount {
  display: inline-flex;
  align-items: center;
  padding: 2px 9px;
  border-radius: 999px;
  background: var(--cui-primary-soft);
  color: var(--cui-primary);
  font-size: 11px;
  font-weight: 700;
  white-space: nowrap;
  animation: cat-countPop 0.18s ease both;
}

@keyframes cat-countPop {
  from { opacity: 0; transform: scale(0.85); }
  to { opacity: 1; transform: scale(1); }
}


.cat-drawerClose:active {
  transform: rotate(90deg) scale(0.92);
}

/* the ONLY scrollable part of the drawer */
/* Two-column grid: fields span both columns unless they are half: true
   (e.g. Start / End date side by side). Phones: always one column. */
.cat-drawerBody {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain; /* scrolling the drawer never scrolls the page */
  padding: 18px 18px 20px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  align-content: start;
  gap: 16px 12px;
  /* Firefox */
  scrollbar-width: thin;
  scrollbar-color: #c3c8d4 transparent;
}

/* slim rounded scrollbar (Chrome / Edge / Safari), same as the table */
.cat-drawerBody::-webkit-scrollbar {
  width: 8px;
}

.cat-drawerBody::-webkit-scrollbar-track {
  margin: 6px 0;
  background: transparent;
}

.cat-drawerBody::-webkit-scrollbar-thumb {
  border: 2px solid #fff;
  border-radius: 999px;
  background: #c3c8d4;
}

.cat-drawerBody::-webkit-scrollbar-thumb:hover {
  background: var(--cat-accent);
}

.cat-drawerField {
  grid-column: span 2;
  min-width: 0;
}

.cat-drawerField-half {
  grid-column: span 1;
}

@media (max-width: 480px) {
  .cat-drawerField-half {
    grid-column: span 2;
  }
}

/* Legacy label style — direct children only, so it never restyles the
   labels inside the Custom* fields now used in the drawer */
.cat-drawerField > label {
  display: block;
  font-size: 11.5px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #56617a;
  margin-bottom: 7px;
}

.cat-drawerInput {
  width: 100%;
  padding: 9px 11px;
  font-size: 13px;
  border: 1.5px solid #e6e9f0;
  border-radius: 9px;
  background: #f8fafc;
  color: #0f172a;
  outline: none;
  transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;
}

.cat-drawerInput:focus {
  border-color: var(--cat-accent);
  background: #ffffff;
  box-shadow: 0 0 0 3px var(--cui-primary-ring);
}

/* ---------- custom-chevron select (native <select>, styled trigger) ---------- */

.cat-selectWrap {
  position: relative;
}

.cat-drawerSelect {
  width: 100%;
  padding: 9px 34px 9px 11px;
  font-size: 13px;
  border: 1.5px solid #e6e9f0;
  border-radius: 9px;
  background: #f8fafc;
  color: #0f172a;
  outline: none;
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;
}

.cat-drawerSelect:focus {
  border-color: var(--cat-accent);
  background: #ffffff;
  box-shadow: 0 0 0 3px var(--cui-primary-ring);
}

.cat-selectChevron {
  position: absolute;
  right: 11px;
  top: 50%;
  transform: translateY(-50%);
  width: 15px;
  height: 15px;
  color: #94a1b8;
  pointer-events: none;
}

.cat-selectWrap:focus-within .cat-selectChevron {
  color: var(--cat-accent);
}

/* ---------- toggle field ---------- */

.cat-drawerField-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.cat-drawerField-toggle label {
  margin-bottom: 0;
}

.cat-toggleTrack {
  position: relative;
  flex-shrink: 0;
  width: 42px;
  height: 24px;
  border: none;
  border-radius: 999px;
  background: #d7dbe3;
  cursor: pointer;
  padding: 0;
  transition: background 0.2s ease;
}

.cat-toggleTrack-on {
  background: var(--cat-accent);
}

.cat-toggleThumb {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);
  transition: left 0.2s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.cat-toggleTrack-on .cat-toggleThumb {
  left: 20px;
}

/* ---------- radio field ---------- */

.cat-radioGroup {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.cat-radioOption {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 7px 12px;
  font-size: 12.5px;
  font-weight: 500;
  color: #0f172a;
  text-transform: none;
  letter-spacing: normal;
  background: #f8fafc;
  border: 1.5px solid #e6e9f0;
  border-radius: 999px;
  cursor: pointer;
  transition: border-color 0.12s ease, background 0.12s ease, color 0.12s ease;
}

.cat-radioOption:hover {
  border-color: #c7d2ff;
}

.cat-radioOption-selected {
  background: #eef4ff;
  border-color: var(--cat-accent);
  color: var(--cat-accent-dark);
  font-weight: 700;
}

.cat-radioOption input[type="radio"] {
  position: absolute;
  opacity: 0;
  width: 1px;
  height: 1px;
}

.cat-radioDot {
  width: 13px;
  height: 13px;
  border-radius: 50%;
  border: 1.5px solid #94a1b8;
  position: relative;
  flex-shrink: 0;
}

.cat-radioOption-selected .cat-radioDot {
  border-color: var(--cat-accent);
}

.cat-radioOption-selected .cat-radioDot::after {
  content: "";
  position: absolute;
  inset: 2px;
  border-radius: 50%;
  background: var(--cat-accent);
}

/* fixed footer — never scrolls, regardless of field count above */
.cat-drawerFooter {
  flex-shrink: 0;
  display: flex;
  gap: 10px;
  padding: 14px 18px;
  border-top: 1px solid #e6e9f0;
  background: #fff;
}

.cat-drawerResetBtn {
  flex: 1 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 10px 14px;
  font-size: 13px;
  font-weight: 600;
  border-radius: 8px;
    border: 1px solid #fecaca;
  background: linear-gradient(
    135deg,
    #fee2e2 0%,
    #fecaca 100%
  );

  color: #b91c1c;
  cursor: pointer;
 transition:
    background 0.15s ease,
    border-color 0.15s ease,
    box-shadow 0.15s ease,
    transform 0.1s ease;
}

.cat-drawerResetBtn:hover {
  background: linear-gradient(
    135deg,
    #fecaca 0%,
    #fca5a5 100%
  );

  border-color: #fca5a5;

  box-shadow:
    0 4px 12px rgba(220, 38, 38, 0.18);
}

.cat-drawerResetBtn:active {
  transform: scale(0.98);
}

.cat-drawerResetBtn:focus-visible {
  outline: none;

  box-shadow:
    0 0 0 3px rgba(220, 38, 38, 0.18);
}

.cat-drawerResetBtn:disabled {
  background: #f1f5f9;
  border-color: #e2e8f0;
  color: #94a3b8;
  cursor: not-allowed;
  box-shadow: none;
}

.cat-drawerApplyBtn {
  flex: 2 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;

  width: 100%;
  min-height: 38px;

  padding: 8px 16px;

  font-size: 13px;
  font-weight: 700;
  line-height: 1;

  border-radius: 8px;
  border: 1px solid var(--cat-accent);

  background: linear-gradient(
    135deg,
    var(--cat-accent) 0%,
    var(--cat-accent) 50%,
    var(--cat-accent-dark) 100%
  );

  color: #ffffff;
  cursor: pointer;

  box-shadow:
    0 4px 12px rgba(79, 95, 232, 0.25);

  transition:
    transform 0.15s ease,
    box-shadow 0.15s ease,
    filter 0.15s ease;
}

.cat-drawerApplyBtn:hover {
  filter: brightness(1.05);

  box-shadow:
    0 6px 18px rgba(79, 95, 232, 0.35);
}

.cat-drawerApplyBtn:active {
  transform: scale(0.98);
}

.cat-drawerApplyBtn:focus-visible {
  outline: none;
  box-shadow:
    0 0 0 3px var(--cui-primary-ring);
}

.cat-drawerApplyBtn:disabled {
  background: #cbd5e1;
  border-color: #cbd5e1;
  box-shadow: none;
  color: #64748b;
  cursor: not-allowed;
}

@media (max-width: 480px) {
  .cat-drawer {
    width: 100vw;
    max-width: 100vw;
  }
}
/* Footer buttons (CustomButton) share the row equally */
.cat-drawerFooter > .cbtn {
  flex: 1 1;
}
`, "",{"version":3,"sources":["webpack://./src/Component/CustomAdminTable/CustomAdminTable.css"],"names":[],"mappings":"AAAA,gGAAgG;AAChG;;EAEE,gCAAgC;EAChC,0CAA0C;EAC1C,2CAA2C;EAC3C,0BAA0B;EAC1B,uBAAuB;EACvB,wBAAwB;EACxB,oCAAoC;EACpC,4BAA4B;EAC5B,wCAAwC;EACxC,+BAA+B;EAC/B,yCAAyC;EACzC,sBAAsB;EACtB,2BAA2B;EAC3B,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uCAAuC;EACvC,8BAA8B;EAC9B,mCAAmC;EACnC,mBAAmB;EACnB,oFAAoF;EACpF,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;;+DAI+D;;AAE/D;;;EAGE;AACF;EACE,cAAc;EACd,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,0CAA0C;EAC1C,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe,EAAE,6CAA6C;EAC9D,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,SAAS;EACT,iBAAiB;EACjB,YAAY;EACZ,uBAAuB,EAAE,0DAA0D;AACrF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,eAAe,EAAE,uEAAuE;EACxF,QAAQ;EACR,cAAc;EACd,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA,yCAAyC;;AAEzC;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,iCAAiC,EAAE,mCAAmC;EACtE,eAAe;EACf,+BAA+B;EAC/B,uDAAuD;EACvD,gCAAgC;EAChC,aAAa;EACb,mCAAmC;EACnC,qBAAqB;EACrB,iFAAiF;AACnF;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,6CAA6C;AAC/C;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,0BAA0B;EAC1B,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,QAAQ;EACR,YAAY;EACZ,eAAe;AACjB;;AAEA,yFAAyF;AACzF;EACE,eAAe;EACf,YAAY;AACd;;AAEA,2DAA2D;;AAE3D;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gCAAgC,IAAI,6CAA6C;EACjF,iCAAiC;EACjC,gCAAgC;EAChC,uDAAuD;EACvD,8BAA8B;EAC9B,0BAA0B;EAC1B,eAAe;EACf,4EAA4E;AAC9E;;AAEA;EACE,kCAAkC;EAClC,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,qCAAqC,EAAE,sBAAsB;EAC7D,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;EAChC,uDAAuD;EACvD,8BAA8B;EAC9B,0BAA0B;EAC1B,eAAe;EACf,4EAA4E;AAC9E;;AAEA;EACE,kCAAkC;EAClC,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA,2EAA2E;;AAE3E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;;+DAE+D;;AAE/D;+DAC+D;AAC/D;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,cAAc;EACd,8BAA8B;EAC9B,YAAY;EACZ,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA,2EAA2E;AAC3E;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,yCAAyC;EACzC,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;AACrC;;AAEA,yEAAyE;AACzE;;EAEE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,YAAY,EAAE,wCAAwC;EACtD,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,OAAO;EACP,0EAA0E;AAC5E;;AAEA;EACE,mCAAmC;EACnC,yEAAyE;AAC3E;;AAEA;;EAEE,UAAU;AACZ;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,mCAAmC;EACnC,kBAAkB;EAClB,qCAAqC;EACrC,qBAAqB;EACrB,kDAAkD;EAClD,eAAe;EACf,0BAA0B;EAC1B,0CAA0C;EAC1C;wBACsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,6CAA6C;AAC/C;;AAEA,6DAA6D;AAC7D;;EAEE,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;;EAEE,uCAAuC;AACzC;;AAEA;EACE,UAAU;AACZ;;AAEA,4EAA4E;AAC5E;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;EAChD,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA,qDAAqD;AACrD;EACE;IACE,WAAW;IACX,YAAY;EACd;;EAEA,sBAAsB,SAAS,EAAE;EACjC,uBAAuB,+CAA+C,EAAE;AAC1E;;AAEA;EACE,iBAAiB,eAAe,EAAE;AACpC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,uFAAuF;;AAEvF;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,iCAAiC;EACjC,mCAAmC;EACnC,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,4FAA4F;AAC5F;EACE,kBAAkB;EAClB,wCAAwC;EACxC,yCAAyC;AAC3C;;AAEA;EACE,8BAA8B,EAAE,0BAA0B;EAC1D,eAAe;AACjB;;AAEA,gFAAgF;AAChF;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,kEAAkE;;AAElE;EACE,8BAA8B;EAC9B,eAAe;EACf,qBAAqB;EACrB,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA,+CAA+C;AAC/C;EACE,gBAAgB;EAChB,mCAAmC;AACrC;AACA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA,qDAAqD;;AAErD;;EAEE,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA,2DAA2D;;AAE3D;;EAEE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,QAAQ;EACR,UAAU;EACV,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,UAAU;EACV,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,6CAA6C;AAC/C;;AAEA;;6CAE6C;AAC7C;EACE,mDAAmD;AACrD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,mBAAmB;AACrB;;AAEA,uDAAuD;;AAEvD;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,uBAAuB;EACvB,0BAA0B;EAC1B,eAAe;EACf,4EAA4E;AAC9E;;AAEA;EACE,kCAAkC;EAClC,wBAAwB;AAC1B;;AAEA;EACE,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,wBAAwB;AAC1B;;AAEA,oEAAoE;AACpE;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,wBAAwB;EACxB,SAAS;EACT,2CAA2C;EAC3C,0BAA0B;EAC1B,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;EACV,oBAAoB;EACpB,oDAAoD;EACpD,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,yCAAyC;AAC3C;AACA;EACE,eAAe;EACf,iCAAiC;EACjC,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE;IACE,UAAU;IACV,gCAAgC;EAClC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;AACA,wCAAwC;;AAExC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,wBAAwB;AAC1B;;AAEA;EACE,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;EAClC,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;;+DAE+D;;AAE/D;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,yEAAyE;EACzE,0BAA0B;EAC1B,yCAAyC;AAC3C;;AAEA;EACE;IACE,6BAA6B;EAC/B;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;;+DAE+D;;AAE/D;EACE,gBAAgB;EAChB,OAAO;EACP,SAAS;EACT,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,aAAa;EACb,qCAAqC;EACrC,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,wCAAwC;AAC1C;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;;+DAE+D;;AAE/D;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;;+DAE+D;;AAE/D;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,uCAAuC;EACvC,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;EACnC,kBAAkB;EAClB,8BAA8B;EAC9B,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,8BAA8B;EAC9B,mCAAmC;EACnC,kBAAkB;EAClB,eAAe;EACf,4EAA4E;AAC9E;;AAEA,oFAAoF;AACpF;;EAEE,2CAA2C;EAC3C,wCAAwC;EACxC,iCAAiC;EACjC,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;;EAGE,sCAAsC;EACtC,wCAAwC;EACxC,WAAW;AACb;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;;+DAE+D;;AAE/D;;;;;EAKE;AACF;EACE;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,eAAe;EACjB;EACA;IACE,cAAc;IACd,YAAY;EACd;EACA;IACE,cAAc;IACd,cAAc;EAChB;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;;;;EAIE;AACF;EACE;IACE,aAAa;IACb,QAAQ;EACV;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;IACZ,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,uBAAuB,EAAE,gDAAgD;EAC3E;EACA;IACE,cAAc;EAChB;EACA;;IAEE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;IACd,uBAAuB;IACvB,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;EACA;IACE,8BAA8B;EAChC;AACF;;AAEA;;+DAE+D;;AAE/D;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,iCAAiC;EACjC,0BAA0B;EAC1B,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB;;oCAEkC;EAClC,sEAAsE;AACxE;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;GACtB,mBAAmB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf;;;wBAGsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,kDAAkD;AACpD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,sCAAsC;EACxC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;;+DAE+D;;AAE/D;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,qCAAqC,EAAE,sBAAsB;EAC7D,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;EAChC,uDAAuD;EACvD,8BAA8B;EAC9B,0BAA0B;EAC1B,eAAe;EACf,4EAA4E;AAC9E;;AAEA;EACE,kCAAkC;EAClC,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA,iHAAiH;AACjH;EACE,oBAAoB;EACpB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,6BAA6B;EAC7B,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;;;+DAK+D;;AAE/D;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,aAAa;EACb,+BAA+B;EAC/B,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,aAAa;EACb,cAAc,EAAE,wDAAwD;EACxE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,oDAAoD;EACpD,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,sCAAsC;EACtC;;qDAEmD;EACnD,0CAA0C;AAC5C;;;AAGA;EACE,WAAW;;EAEX,kBAAkB;EAClB,OAAO;EACP,YAAY;;EAEZ,WAAW;EACX,WAAW;;EAEX;;;;;GAKC;AACH;;;AAGA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,yFAAyF;EACzF,WAAW;EACX;;2CAEyC;AAC3C;;;AAGA;EACE,SAAS;;EAET,eAAe;EACf,gBAAgB;;EAEhB,cAAc;;EAEd,uBAAuB;AACzB;;;AAGA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;;AAGA,iBAAiB;;AAEjB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,UAAU;EACV,mCAAmC;EACnC,kBAAkB;EAClB,oCAAoC;EACpC,4BAA4B;EAC5B,eAAe;EACf;wBACsB;AACxB;;AAEA;EACE,sCAAsC;EACtC,kCAAkC;EAClC,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,6CAA6C;AAC/C;;AAEA,mCAAmC;AACnC;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,mCAAmC;EACnC,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,OAAO,UAAU,EAAE,sBAAsB,EAAE;EAC3C,KAAK,UAAU,EAAE,mBAAmB,EAAE;AACxC;;;AAGA;EACE,oCAAoC;AACtC;;AAEA,2CAA2C;AAC3C;qEACqE;AACrE;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,4BAA4B,EAAE,gDAAgD;EAC9E,uBAAuB;EACvB,aAAa;EACb,gDAAgD;EAChD,oBAAoB;EACpB,cAAc;EACd,YAAY;EACZ,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA,uEAAuE;AACvE;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;4DAC4D;AAC5D;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,iFAAiF;AACnF;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA,kFAAkF;;AAElF;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,iFAAiF;AACnF;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,uCAAuC;;AAEvC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;EACzC,uDAAuD;AACzD;;AAEA;EACE,UAAU;AACZ;;AAEA,sCAAsC;;AAEtC;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,oBAAoB;EACpB,eAAe;EACf,4EAA4E;AAC9E;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA,kEAAkE;AAClE;EACE,cAAc;EACd,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;IAChB,yBAAyB;EAC3B;;;;GAIC;;EAED,cAAc;EACd,eAAe;CAChB;;;;uBAIsB;AACvB;;AAEA;EACE;;;;GAIC;;EAED,qBAAqB;;EAErB;sCACoC;AACtC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;;EAEb;qCACmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;;EAER,WAAW;EACX,gBAAgB;;EAEhB,iBAAiB;;EAEjB,eAAe;EACf,gBAAgB;EAChB,cAAc;;EAEd,kBAAkB;EAClB,mCAAmC;;EAEnC;;;;;GAKC;;EAED,cAAc;EACd,eAAe;;EAEf;sCACoC;;EAEpC;;;qBAGmB;AACrB;;AAEA;EACE,wBAAwB;;EAExB;sCACoC;AACtC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb;qCACmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE;IACE,YAAY;IACZ,gBAAgB;EAClB;AACF;AACA,wDAAwD;AACxD;EACE,SAAO;AACT","sourcesContent":["/* colour tokens — also on the standalone Filters button (CustomFilterButton in a page header) */\n.cat-wrap,\n.cat-filterBtnStandalone {\n  --cat-accent: var(--cui-primary);\n  --cat-accent-soft: var(--cui-primary-soft);\n  --cat-accent-dark: var(--cui-primary-hover);\n  --cat-ink: var(--cui-text);\n  --cat-ink-soft: #56617a;\n  --cat-ink-faint: #94a1b8;\n  --cat-border: var(--cui-border-soft);\n  --cat-surface: var(--cui-bg);\n  --cat-surface-soft: var(--cui-bg-subtle);\n  --cat-danger: var(--cui-danger);\n  --cat-danger-soft: var(--cui-danger-soft);\n  --cat-success: #12805c;\n  --cat-success-soft: #e5f6ee;\n  --cat-warning: #a15c00;\n  --cat-warning-soft: #fdf1de;\n}\n\n.cat-wrap {\n  display: flex;\n  flex-direction: column;\n  max-height: var(--cat-max-height, 70vh);\n  background: var(--cat-surface);\n  border: 1px solid var(--cat-border);\n  border-radius: 14px;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 6px 16px -8px rgba(15, 23, 42, 0.08);\n  overflow: hidden;\n}\n\n.cat-wrap * {\n  box-sizing: border-box;\n}\n\n/* ==========================================================\n   TOOLBAR — 3 zones: title (left) / search+filters (center) /\n   primary actions (right). Grid so the center zone can genuinely\n   center itself instead of just sitting in leftover flex space.\n   ========================================================== */\n\n/*\n * Wrapping flex layout (not a fixed grid): on wide screens the three zones sit on one row;\n * as space runs out they wrap onto new rows instead of overflowing. See RESPONSIVE below.\n */\n.cat-toolbar {\n  flex-shrink: 0;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 10px 12px;\n  padding: 12px 16px;\n  border-bottom: 1px solid var(--cat-border);\n  background: var(--cat-surface);\n}\n\n.cat-toolbarLeft {\n  display: flex;\n  align-items: center;\n  flex: 1 1 180px; /* grows, but gives way to search + actions */\n  min-width: 0;\n}\n\n.cat-title {\n  font-size: 14.5px;\n  font-weight: 700;\n  color: var(--cat-ink);\n  margin: 0;\n  line-height: 1.35;\n  min-width: 0;\n  overflow-wrap: anywhere; /* long titles wrap instead of pushing the toolbar wider */\n}\n\n.cat-toolbarCenter {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  flex-wrap: wrap;\n  flex: 1 1 240px;\n  min-width: 0;\n}\n\n.cat-toolbarCenter:empty {\n  display: none;\n}\n\n.cat-toolbarRight {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  flex-wrap: wrap; /* buttons, badges and dropdowns wrap instead of running off the edge */\n  gap: 8px;\n  flex: 0 1 auto;\n  min-width: 0;\n  max-width: 100%;\n  margin-left: auto;\n}\n\n/* ---------- premium search ---------- */\n\n.cat-search {\n  position: relative;\n  flex: 1 1 220px;\n  min-width: 180px;\n  max-width: 420px;\n}\n\n.cat-searchIcon {\n  position: absolute;\n  left: 11px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 14px;\n  height: 14px;\n  color: var(--cat-ink-faint);\n  pointer-events: none;\n}\n\n.cat-searchInput {\n  width: 100%;\n  height: var(--cui-control-height); /* same height as toolbar buttons */\n  padding: 0 32px;\n  font-size: var(--cui-font-size);\n  border: var(--cui-border-width) solid var(--cat-border);\n  border-radius: var(--cui-radius);\n  outline: none;\n  background: var(--cat-surface-soft);\n  color: var(--cat-ink);\n  transition: border-color 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;\n}\n\n.cat-searchInput::placeholder {\n  color: var(--cat-ink-faint);\n}\n\n.cat-searchInput:focus {\n  border-color: var(--cat-accent);\n  background: var(--cat-surface);\n  box-shadow: 0 0 0 3px var(--cui-primary-ring);\n}\n\n.cat-searchClear,\n.cat-searchSpinner {\n  position: absolute;\n  right: 9px;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.cat-searchClear {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  border: none;\n  border-radius: 50%;\n  background: var(--cat-border);\n  color: var(--cat-ink-soft);\n  cursor: pointer;\n  padding: 0;\n}\n\n.cat-searchClear:hover {\n  background: #d7dce6;\n}\n\n.cat-searchSpinner {\n  width: 14px;\n  height: 14px;\n  color: var(--cat-accent);\n  animation: cat-spin 0.8s linear infinite;\n}\n\n.cat-filters {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.cat-toolbarActions {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  gap: 8px;\n  min-width: 0;\n  max-width: 100%;\n}\n\n/* page-supplied controls (dropdown wrappers, buttons, badges) never exceed the toolbar */\n.cat-toolbarActions > * {\n  max-width: 100%;\n  min-width: 0;\n}\n\n/* ---------- refresh / export toolbar buttons ---------- */\n\n.cat-refreshBtn {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: var(--cui-control-height);   /* square, same height as the other buttons */\n  height: var(--cui-control-height);\n  border-radius: var(--cui-radius);\n  border: var(--cui-border-width) solid var(--cat-border);\n  background: var(--cat-surface);\n  color: var(--cat-ink-soft);\n  cursor: pointer;\n  transition: background 0.12s ease, color 0.12s ease, border-color 0.12s ease;\n}\n\n.cat-refreshBtn:hover:not(:disabled) {\n  background: var(--cat-accent-soft);\n  color: var(--cat-accent);\n  border-color: #c7d2ff;\n}\n\n.cat-refreshBtn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.cat-spinning {\n  animation: cat-spin 0.8s linear infinite;\n}\n\n.cat-exportBtn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n  min-height: var(--cui-control-height); /* = CustomButton md */\n  padding: 8px 16px;\n  font-size: 13.5px;\n  font-weight: 600;\n  line-height: 1.2;\n  white-space: nowrap;\n  border-radius: var(--cui-radius);\n  border: var(--cui-border-width) solid var(--cat-border);\n  background: var(--cat-surface);\n  color: var(--cat-ink-soft);\n  cursor: pointer;\n  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n}\n\n.cat-exportBtn:hover {\n  background: var(--cat-accent-soft);\n  color: var(--cat-accent);\n  border-color: #c7d2ff;\n}\n\n/* ---------- inline \"loading...\" label next to search/filters ---------- */\n\n.cat-loadingLabel {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  color: var(--cat-ink-faint);\n}\n\n.cat-loadingLabelSpinner {\n  width: 13px;\n  height: 13px;\n  animation: cat-spin 0.8s linear infinite;\n}\n\n/* ==========================================================\n   SCROLL REGION\n   ========================================================== */\n\n/* Wrapper holds the scroll area + the ◀ ▶ ↑ buttons, which must NOT\n   scroll with the content, so they live outside .cat-scroll. */\n.cat-scrollWrap {\n  position: relative;\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  min-height: 0;\n}\n\n.cat-scroll {\n  position: relative;\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow: auto;\n  overscroll-behavior-x: contain;\n  /* Firefox */\n  scrollbar-width: thin;\n  scrollbar-color: #c3c8d4 transparent;\n}\n\n/* ---------- slim rounded scrollbars (Chrome / Edge / Safari) ---------- */\n.cat-scroll::-webkit-scrollbar {\n  width: 10px;\n  height: 10px;\n}\n\n.cat-scroll::-webkit-scrollbar-track {\n  background: var(--cat-surface-soft);\n}\n\n.cat-scroll::-webkit-scrollbar-thumb {\n  border: 2px solid var(--cat-surface-soft);\n  border-radius: 999px;\n  background: #c3c8d4;\n}\n\n.cat-scroll::-webkit-scrollbar-thumb:hover {\n  background: var(--cat-accent);\n}\n\n.cat-scroll::-webkit-scrollbar-corner {\n  background: var(--cat-surface-soft);\n}\n\n/* ---------- edge fades: show there's more content sideways ---------- */\n.cat-scrollWrap::before,\n.cat-scrollWrap::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  bottom: 10px; /* stop above the horizontal scrollbar */\n  z-index: 4;\n  width: 32px;\n  pointer-events: none;\n  opacity: 0;\n  transition: opacity 0.2s ease;\n}\n\n.cat-scrollWrap::before {\n  left: 0;\n  background: linear-gradient(to right, rgba(15, 23, 42, 0.08), transparent);\n}\n\n.cat-scrollWrap::after {\n  right: var(--cat-sticky-right, 0px);\n  background: linear-gradient(to left, rgba(15, 23, 42, 0.08), transparent);\n}\n\n.cat-canLeft::before,\n.cat-canRight::after {\n  opacity: 1;\n}\n\n/* ---------- ◀ ▶ ↑ buttons ---------- */\n.cat-scrollBtn {\n  position: absolute;\n  z-index: 6;\n  display: grid;\n  place-items: center;\n  width: 36px;\n  height: 36px;\n  padding: 0;\n  border: 1px solid var(--cat-border);\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.96);\n  color: var(--cat-ink);\n  box-shadow: 0 6px 18px -6px rgba(15, 23, 42, 0.35);\n  cursor: pointer;\n  backdrop-filter: blur(4px);\n  animation: cat-scrollBtnIn 0.15s ease both;\n  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease,\n    transform 0.15s ease;\n}\n\n.cat-scrollBtn:hover {\n  border-color: var(--cat-accent);\n  background: var(--cat-accent);\n  color: #fff;\n}\n\n.cat-scrollBtn:active {\n  transform: scale(0.94);\n}\n\n.cat-scrollBtn:focus-visible {\n  outline: none;\n  box-shadow: 0 0 0 3px var(--cui-primary-ring);\n}\n\n/* Vertically centred on the body (below the sticky header) */\n.cat-scrollBtn-left,\n.cat-scrollBtn-right {\n  top: calc(50% + var(--cat-header-h, 48px) / 2);\n  transform: translateY(-50%);\n}\n\n.cat-scrollBtn-left:active,\n.cat-scrollBtn-right:active {\n  transform: translateY(-50%) scale(0.94);\n}\n\n.cat-scrollBtn-left {\n  left: 10px;\n}\n\n/* Sits just left of the sticky Actions column so it never covers a button */\n.cat-scrollBtn-right {\n  right: calc(var(--cat-sticky-right, 0px) + 10px);\n}\n\n.cat-scrollBtn-top {\n  right: calc(var(--cat-sticky-right, 0px) + 14px);\n  bottom: 20px;\n  border-color: transparent;\n  background: var(--cat-accent);\n  color: #fff;\n}\n\n.cat-scrollBtn-top:hover {\n  background: var(--cat-accent-dark);\n}\n\n@keyframes cat-scrollBtnIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n/* Phones: swipe works, so keep the buttons smaller */\n@media (max-width: 576px) {\n  .cat-scrollBtn {\n    width: 30px;\n    height: 30px;\n  }\n\n  .cat-scrollBtn-left { left: 6px; }\n  .cat-scrollBtn-right { right: calc(var(--cat-sticky-right, 0px) + 6px); }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .cat-scrollBtn { animation: none; }\n}\n\n.cat-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  font-size: 13px;\n}\n\n.cat-dense .cat-table {\n  font-size: 12.5px;\n}\n\n/* ---------- header: height driven by rowHeight preset, sticky by default ---------- */\n\n.cat-table thead th {\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  height: var(--cat-header-h, 48px);\n  background: var(--cat-surface-soft);\n  color: var(--cat-ink-soft);\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  padding: 0 14px;\n  border-bottom: 1px solid var(--cat-border);\n  white-space: nowrap;\n  text-align: left;\n}\n\n/* grouped header (columns with `group`): merged group cell on row 1, its columns on row 2 */\n.cat-table thead th.cat-thGroup {\n  text-align: center;\n  border-left: 1px solid var(--cat-border);\n  border-right: 1px solid var(--cat-border);\n}\n\n.cat-table thead tr.cat-thSubRow th {\n  top: var(--cat-header-h, 48px); /* pins just under row 1 */\n  font-size: 10px;\n}\n\n/* stickyHeader={false} — header scrolls away with the body instead of pinning */\n.cat-headerStatic .cat-table thead th {\n  position: static;\n}\n\n.cat-dense .cat-table thead th {\n  padding: 0 12px;\n}\n\n.cat-thContent {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.cat-thSortable {\n  cursor: pointer;\n  user-select: none;\n}\n\n.cat-thSortable:hover {\n  color: var(--cat-ink);\n}\n\n.cat-sortIcon {\n  width: 13px;\n  height: 13px;\n  flex-shrink: 0;\n}\n\n.cat-sortIcon-idle {\n  color: #c3c8d4;\n}\n\n.cat-sortIcon-active {\n  color: var(--cat-accent);\n}\n\n/* ---------- rows: height driven by rowHeight preset ---------- */\n\n.cat-table tbody td {\n  height: var(--cat-row-h, 52px);\n  padding: 0 14px;\n  color: var(--cat-ink);\n  border-bottom: 1px solid #eef0f5;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 320px;\n  vertical-align: middle;\n}\n\n.cat-dense .cat-table tbody td {\n  padding: 0 12px;\n}\n\n.cat-tdWrap {\n  white-space: normal;\n  text-overflow: clip;\n  height: auto;\n  padding-top: 10px;\n  padding-bottom: 10px;\n}\n\n.cat-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.cat-table tbody tr:nth-child(even) td {\n  background: #fbfcfe;\n}\n\n.cat-table tbody tr:hover td {\n  background: var(--cat-accent-soft);\n}\n\n.cat-rowClickable {\n  cursor: pointer;\n}\n\n.cat-rowSelected td {\n  background: var(--cat-accent-soft) !important;\n}\n\n/* subtotal / grand-total rows (rowClassName) */\n.cat-rowTotal td {\n  font-weight: 700;\n  background: var(--cat-surface-soft);\n}\n.cat-rowGrandTotal td {\n  font-weight: 700;\n  background: var(--cat-accent-soft);\n  color: var(--cat-accent-dark);\n}\n\n/* ---------- selection + serial columns ---------- */\n\n.cat-selectCol,\n.cat-serialCol {\n  width: 1%;\n  white-space: nowrap;\n  text-align: center;\n  color: var(--cat-ink-faint);\n  font-variant-numeric: tabular-nums;\n}\n\n.cat-selectCol input[type=\"checkbox\"],\n.cat-serialCol {\n  accent-color: var(--cat-accent);\n}\n\n.cat-selectCol input[type=\"checkbox\"] {\n  width: 15px;\n  height: 15px;\n  cursor: pointer;\n}\n\n/* ---------- sticky right-hand actions column ---------- */\n\n.cat-actionsCol,\n.cat-actionsCell {\n  text-align: right;\n}\n\n.cat-sticky {\n  position: sticky;\n  right: 0;\n  z-index: 1;\n  background: var(--cat-surface);\n  transition: box-shadow 0.15s ease;\n}\n\nth.cat-sticky {\n  z-index: 3;\n  background: var(--cat-surface-soft);\n}\n\n.cat-table tbody tr:nth-child(even) td.cat-sticky {\n  background: #fbfcfe;\n}\n\n.cat-table tbody tr:hover td.cat-sticky,\n.cat-rowSelected td.cat-sticky {\n  background: var(--cat-accent-soft) !important;\n}\n\n/* Shadow only appears once the table has actually been scrolled\n   horizontally — otherwise a static shadow on an unscrolled table\n   just looks like a stray visual artifact. */\n.cat-scrolledX .cat-sticky {\n  box-shadow: -8px 0 12px -6px rgba(15, 23, 42, 0.14);\n}\n\n.cat-actionsRow {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 4px;\n  white-space: nowrap;\n}\n\n/* ---------- circular icon action buttons ---------- */\n\n.cat-iconBtn {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  border: 1px solid transparent;\n  background: transparent;\n  color: var(--cat-ink-soft);\n  cursor: pointer;\n  transition: background 0.12s ease, color 0.12s ease, border-color 0.12s ease;\n}\n\n.cat-iconBtn-view:hover {\n  background: var(--cat-accent-soft);\n  color: var(--cat-accent);\n}\n\n.cat-iconBtn-edit:hover {\n  background: var(--cat-warning-soft);\n  color: var(--cat-warning);\n}\n\n.cat-iconBtn-delete:hover {\n  background: var(--cat-danger-soft);\n  color: var(--cat-danger);\n}\n\n/* Lightweight CSS-only tooltip via data-tooltip, no extra JS/deps */\n.cat-iconBtn::after {\n  content: attr(data-tooltip);\n  position: absolute;\n  bottom: calc(100% + 6px);\n  left: 50%;\n  transform: translateX(-50%) translateY(2px);\n  background: var(--cat-ink);\n  color: #fff;\n  font-size: 11px;\n  font-weight: 600;\n  padding: 4px 8px;\n  border-radius: 6px;\n  white-space: nowrap;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.12s ease, transform 0.12s ease;\n  z-index: 5;\n}\n\n.cat-iconBtn:hover::after {\n  opacity: 1;\n  transform: translateX(-50%) translateY(0);\n}\n.cat-portalTooltip {\n  position: fixed;\n  transform: translate(-50%, -100%);\n  background: #0f172a;\n  color: #fff;\n  font-size: 11px;\n  font-weight: 600;\n  padding: 4px 8px;\n  border-radius: 6px;\n  white-space: nowrap;\n  pointer-events: none;\n  z-index: 1000;\n  animation: cat-tooltipPop 0.1s ease both;\n}\n\n@keyframes cat-tooltipPop {\n  from {\n    opacity: 0;\n    transform: translate(-50%, -96%);\n  }\n  to {\n    opacity: 1;\n    transform: translate(-50%, -100%);\n  }\n}\n/* ---------- status badges ---------- */\n\n.cat-statusBadge {\n  display: inline-flex;\n  align-items: center;\n  padding: 3px 10px;\n  font-size: 11px;\n  font-weight: 700;\n  border-radius: 999px;\n  white-space: nowrap;\n}\n\n.cat-status-active {\n  background: var(--cat-success-soft);\n  color: var(--cat-success);\n}\n\n.cat-status-approved {\n  background: var(--cat-accent-soft);\n  color: var(--cat-accent);\n}\n\n.cat-status-pending {\n  background: var(--cat-warning-soft);\n  color: var(--cat-warning);\n}\n\n.cat-status-inactive {\n  background: #f1f2f6;\n  color: var(--cat-ink-soft);\n}\n\n.cat-status-rejected {\n  background: var(--cat-danger-soft);\n  color: var(--cat-danger);\n}\n\n.cat-status-default {\n  background: #f1f2f6;\n  color: var(--cat-ink-soft);\n}\n\n/* ==========================================================\n   SKELETON LOADING\n   ========================================================== */\n\n.cat-skeletonRow td {\n  padding: 0 14px;\n}\n\n.cat-skeletonBar {\n  display: block;\n  height: 11px;\n  width: 80%;\n  border-radius: 6px;\n  background: linear-gradient(90deg, #eef0f5 25%, #f7f8fb 37%, #eef0f5 63%);\n  background-size: 400% 100%;\n  animation: cat-shimmer 1.4s ease infinite;\n}\n\n@keyframes cat-shimmer {\n  0% {\n    background-position: 100% 50%;\n  }\n  100% {\n    background-position: 0 50%;\n  }\n}\n\n/* ==========================================================\n   REFETCH OVERLAY\n   ========================================================== */\n\n.cat-loadingOverlay {\n  position: sticky;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 10px;\n  background: rgba(255, 255, 255, 0.72);\n  backdrop-filter: blur(1px);\n  pointer-events: none;\n}\n\n.cat-loadingOverlayText {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--cat-ink-soft);\n}\n\n.cat-loadingSpinner {\n  width: 18px;\n  height: 18px;\n  color: var(--cat-accent);\n  animation: cat-spin 0.8s linear infinite;\n}\n\n@keyframes cat-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* ==========================================================\n   EMPTY STATE\n   ========================================================== */\n\n.cat-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  padding: 44px 20px;\n  color: var(--cat-ink-soft);\n}\n\n.cat-emptyIcon {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background: var(--cat-surface-soft);\n  color: var(--cat-ink-faint);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 12px;\n}\n\n.cat-emptyTitle {\n  font-size: 13.5px;\n  font-weight: 700;\n  color: var(--cat-ink);\n  margin-bottom: 4px;\n}\n\n.cat-emptyDesc {\n  font-size: 12px;\n  color: var(--cat-ink-faint);\n  max-width: 280px;\n}\n\n/* ==========================================================\n   FOOTER / PAGINATION\n   ========================================================== */\n\n.cat-footer {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n  padding: 9px 16px;\n  border-top: 1px solid var(--cat-border);\n  background: var(--cat-surface);\n}\n\n.cat-footerInfo {\n  font-size: 12px;\n  color: var(--cat-ink-soft);\n  white-space: nowrap;\n}\n\n.cat-footerControls {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.cat-pageSize {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  color: var(--cat-ink-soft);\n}\n\n.cat-pageSize select {\n  padding: 4px 7px;\n  font-size: 12.5px;\n  border: 1px solid var(--cat-border);\n  border-radius: 6px;\n  background: var(--cat-surface);\n  outline: none;\n  cursor: pointer;\n}\n\n.cat-pageSize select:focus {\n  border-color: var(--cat-accent);\n}\n\n.cat-pager {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.cat-pageBtn {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 27px;\n  height: 27px;\n  padding: 0 6px;\n  font-size: 12.5px;\n  font-weight: 600;\n  color: var(--cat-ink-soft);\n  background: var(--cat-surface);\n  border: 1px solid var(--cat-border);\n  border-radius: 7px;\n  cursor: pointer;\n  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n}\n\n/* explicit colours so global button / .btn hover styles can't wash the number out */\n.cat-pager .cat-pageBtn:hover:not(:disabled),\n.cat-pager .cat-pageBtn:focus-visible {\n  background: var(--cat-accent-soft, #eef1ff);\n  border-color: var(--cat-accent, #4f5fe8);\n  color: var(--cat-accent, #4f5fe8);\n  opacity: 1;\n}\n\n.cat-pageBtn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.cat-pager .cat-pageBtn-active,\n.cat-pager .cat-pageBtn-active:hover:not(:disabled),\n.cat-pager .cat-pageBtn-active:focus-visible {\n  background: var(--cat-accent, #4f5fe8);\n  border-color: var(--cat-accent, #4f5fe8);\n  color: #fff;\n}\n\n.cat-pageEllipsis {\n  padding: 0 4px;\n  color: var(--cat-ink-faint);\n  font-size: 12.5px;\n}\n\n/* ==========================================================\n   RESPONSIVE\n   ========================================================== */\n\n/*\n * Laptops + tablets: title on its own row. The center wrapper dissolves\n * (display: contents) so search and page filters (status dropdown, etc.) sit\n * on the same row as the button group, all vertically centred. When space runs\n * out the button group drops to its own row, still right-aligned and together.\n */\n@media (max-width: 1199.98px) {\n  .cat-toolbarLeft {\n    flex-basis: 100%;\n  }\n  .cat-toolbarCenter {\n    display: contents;\n  }\n  .cat-search {\n    flex: 1 1 240px;\n    max-width: none;\n  }\n  .cat-filters {\n    flex: 0 1 auto;\n    min-width: 0;\n  }\n  .cat-toolbarRight {\n    flex: 1 1 auto;\n    margin-left: 0;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .cat-toolbar {\n    padding: 12px;\n  }\n}\n\n/*\n * Phones: search gets the full row; page filters (status dropdown, etc.) and\n * the Filters / Export buttons share the next row; toolbar actions (badges,\n * extra buttons) fill the last row.\n */\n@media (max-width: 575.98px) {\n  .cat-toolbar {\n    padding: 10px;\n    gap: 8px;\n  }\n  .cat-title {\n    font-size: 14px;\n  }\n  .cat-search {\n    min-width: 0;\n    flex: 1 1 100%;\n  }\n  .cat-filters {\n    flex: 1 1 170px;\n  }\n  .cat-filters > * {\n    flex: 1 1 150px;\n    min-width: 0 !important; /* dropdown wrappers carry an inline min-width */\n  }\n  .cat-toolbarRight {\n    flex: 1 1 100%;\n  }\n  .cat-exportBtn,\n  .cat-filterBtn {\n    flex: 1 1 auto;\n  }\n  .cat-toolbarActions {\n    flex: 1 1 100%;\n  }\n  .cat-toolbarActions > * {\n    flex: 1 1 auto;\n    justify-content: center;\n    min-width: 0 !important;\n  }\n}\n\n@media (max-width: 640px) {\n  .cat-footer {\n    flex-direction: column;\n    align-items: stretch;\n  }\n  .cat-footerControls {\n    justify-content: space-between;\n  }\n}\n\n/* ==========================================================\n   DELETE CONFIRMATION DIALOG (used when deleteDialog=true)\n   ========================================================== */\n\n.cat-confirmOverlay {\n  position: fixed;\n  inset: 0;\n  z-index: 3000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  background: rgba(15, 23, 42, 0.5);\n  backdrop-filter: blur(2px);\n  animation: cat-confirmFade 0.15s ease both;\n}\n\n.cat-confirmCard {\n  width: 100%;\n  max-width: 380px;\n  background: #fff;\n  border-radius: 16px;\n  padding: 24px;\n  text-align: center;  \n  box-shadow:\n    0 24px 60px -12px rgba(15, 23, 42, 0.4),\n    0 0 0 1px rgba(15, 23, 42, 0.04);\n  animation: cat-confirmPop 0.18s cubic-bezier(0.34, 1.56, 0.64, 1) both;\n}\n\n.cat-confirmIcon {\n  width: 44px;\n  height: 44px;\n  border-radius: 12px;\n  background: #fdeceb;\n  color: #c0273f;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n   margin: 0 auto 14px; \n}\n\n.cat-confirmBody {\n  margin-bottom: 20px;\n}\n\n.cat-confirmTitle {\n  font-size: 15.5px;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0 0 6px;\n}\n\n.cat-confirmMessage {\n  font-size: 13.5px;\n  color: #64748b;\n  line-height: 1.55;\n  margin: 0;\n}\n\n.cat-confirmActions {\n  display: flex;\n  justify-content: center;\n  gap: 32px;\n}\n\n.cat-confirmBtn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 16px;\n  font-size: 13px;\n  font-weight: 600;\n  border-radius: 9px;\n  border: 1px solid transparent;\n  cursor: pointer;\n  transition:\n    background 0.12s ease,\n    border-color 0.12s ease,\n    transform 0.08s ease;\n}\n\n.cat-confirmBtn:active {\n  transform: scale(0.97);\n}\n\n.cat-confirmBtn-cancel {\n  background: #f3f5f9;\n  color: #475569;\n  border-color: #e5e9f0;\n}\n\n.cat-confirmBtn-cancel:hover {\n  background: #e6e9f0;\n}\n\n.cat-confirmBtn-danger {\n  background: #dc2f4c;\n  color: #fff;\n  box-shadow: 0 6px 16px -4px rgba(220, 47, 76, 0.5);\n}\n\n.cat-confirmBtn-danger:hover {\n  background: #c0273f;\n}\n\n@keyframes cat-confirmFade {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes cat-confirmPop {\n  from {\n    opacity: 0;\n    transform: translateY(8px) scale(0.96);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n/* ==========================================================\n   FILTER BUTTON (opens the advanced-filter drawer)\n   ========================================================== */\n\n.cat-filterBtn {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n  min-height: var(--cui-control-height); /* = CustomButton md */\n  padding: 8px 16px;\n  font-size: 13.5px;\n  font-weight: 600;\n  line-height: 1.2;\n  white-space: nowrap;\n  border-radius: var(--cui-radius);\n  border: var(--cui-border-width) solid var(--cat-border);\n  background: var(--cat-surface);\n  color: var(--cat-ink-soft);\n  cursor: pointer;\n  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n}\n\n.cat-filterBtn:hover {\n  background: var(--cat-accent-soft);\n  color: var(--cat-accent);\n  border-color: #c7d2ff;\n}\n\n.cat-filterBtn-active {\n  background: var(--cat-accent-soft);\n  border-color: var(--cat-accent);\n  color: var(--cat-accent);\n}\n\n/* in a page header (PageTitle) App.css turns every `.Title span` into a 180px block on phones — not this badge */\n.Title .cat-filterBtnStandalone .cat-filterBadge {\n  display: inline-flex;\n  max-width: none;\n  overflow: visible;\n}\n.Title .cat-filterBtnStandalone {\n  flex: 0 0 auto;\n}\n\n.cat-filterBadge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 20px;\n  height: 20px;\n  padding: 0 6px;\n  border-radius: 999px;\n  background: var(--cat-accent);\n  color: #fff;\n  font-size: 11px;\n  font-weight: 700;\n}\n\n/* ==========================================================\n   ADVANCED FILTER DRAWER\n   Structure mirrors the table itself: fixed header, scrolling\n   body, fixed footer — so Search never scrolls out of reach no\n   matter how many fields are configured.\n   ========================================================== */\n\n.cat-drawerOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  height: 100vh;\n  z-index: 4000;\n  background: rgba(15, 23, 42, 0);\n  pointer-events: none;\n  transition: background 0.2s ease;\n}\n\n.cat-drawerOverlay-open {\n  background: rgba(15, 23, 42, 0.4);\n  pointer-events: auto;\n}\n\n.cat-drawer {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  height: 100vh;\n  height: 100dvh; /* modern browsers: accounts for mobile browser chrome */\n  width: 420px;\n  max-width: 90vw;\n  background: #fff;\n  box-shadow: -12px 0 32px -12px rgba(15, 23, 42, 0.3);\n  display: flex;\n  flex-direction: column;\n  transform: translateX(100%);\n  transition: transform 0.22s ease;\n}\n\n.cat-drawer-open {\n  transform: translateX(0);\n}\n.cat-drawerHeader {\n  position: relative;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 18px 18px 16px;\n  /* soft brand tint fading into white */\n  background:\n    radial-gradient(120% 140% at 0% 0%, rgba(79, 95, 232, 0.12) 0%, transparent 60%),\n    linear-gradient(180deg, #f7f8ff 0%, #ffffff 100%);\n  border-bottom: 1px solid var(--cat-border);\n}\n\n\n.cat-drawerHeader::after {\n  content: \"\";\n\n  position: absolute;\n  left: 0;\n  bottom: -1px;\n\n  width: 100%;\n  height: 1px;\n\n  background: linear-gradient(\n    90deg,\n    transparent,\n    var(--cui-primary-border),\n    transparent\n  );\n}\n\n\n/* title wrapper */\n.cat-drawerTitleWrap {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 0;\n}\n\n\n.cat-drawerTitleIcon {\n  display: grid;\n  place-items: center;\n  width: 40px;\n  height: 40px;\n  flex-shrink: 0;\n  border-radius: 12px;\n  background: linear-gradient(135deg, var(--cui-primary) 0%, var(--cui-primary-light) 100%);\n  color: #fff;\n  box-shadow:\n    0 8px 18px -8px rgba(79, 95, 232, 0.75),\n    inset 0 1px 0 rgba(255, 255, 255, 0.25);\n}\n\n\n.cat-drawerHeader h4 {\n  margin: 0;\n\n  font-size: 15px;\n  font-weight: 750;\n\n  color: #0f172a;\n\n  letter-spacing: -0.01em;\n}\n\n\n.cat-drawerSubtitle {\n  margin-top: 3px;\n  overflow: hidden;\n  color: var(--cui-text-muted);\n  font-size: 12px;\n  line-height: 1.4;\n  text-overflow: ellipsis;\n}\n\n\n/* close button */\n\n.cat-drawerClose {\n  display: grid;\n  place-items: center;\n  width: 34px;\n  height: 34px;\n  flex-shrink: 0;\n  padding: 0;\n  border: 1px solid var(--cat-border);\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.9);\n  color: var(--cui-text-muted);\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease,\n    transform 0.15s ease;\n}\n\n.cat-drawerClose:hover {\n  border-color: var(--cui-danger-border);\n  background: var(--cui-danger-soft);\n  color: var(--cui-danger);\n  transform: rotate(90deg);\n}\n\n.cat-drawerClose:focus-visible {\n  outline: none;\n  box-shadow: 0 0 0 3px var(--cui-primary-ring);\n}\n\n/* title + live \"n selected\" pill */\n.cat-drawerTitleText {\n  min-width: 0;\n}\n\n.cat-drawerTitleRow {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.cat-drawerCount {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 9px;\n  border-radius: 999px;\n  background: var(--cui-primary-soft);\n  color: var(--cui-primary);\n  font-size: 11px;\n  font-weight: 700;\n  white-space: nowrap;\n  animation: cat-countPop 0.18s ease both;\n}\n\n@keyframes cat-countPop {\n  from { opacity: 0; transform: scale(0.85); }\n  to { opacity: 1; transform: scale(1); }\n}\n\n\n.cat-drawerClose:active {\n  transform: rotate(90deg) scale(0.92);\n}\n\n/* the ONLY scrollable part of the drawer */\n/* Two-column grid: fields span both columns unless they are half: true\n   (e.g. Start / End date side by side). Phones: always one column. */\n.cat-drawerBody {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  overscroll-behavior: contain; /* scrolling the drawer never scrolls the page */\n  padding: 18px 18px 20px;\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  align-content: start;\n  gap: 16px 12px;\n  /* Firefox */\n  scrollbar-width: thin;\n  scrollbar-color: #c3c8d4 transparent;\n}\n\n/* slim rounded scrollbar (Chrome / Edge / Safari), same as the table */\n.cat-drawerBody::-webkit-scrollbar {\n  width: 8px;\n}\n\n.cat-drawerBody::-webkit-scrollbar-track {\n  margin: 6px 0;\n  background: transparent;\n}\n\n.cat-drawerBody::-webkit-scrollbar-thumb {\n  border: 2px solid #fff;\n  border-radius: 999px;\n  background: #c3c8d4;\n}\n\n.cat-drawerBody::-webkit-scrollbar-thumb:hover {\n  background: var(--cat-accent);\n}\n\n.cat-drawerField {\n  grid-column: span 2;\n  min-width: 0;\n}\n\n.cat-drawerField-half {\n  grid-column: span 1;\n}\n\n@media (max-width: 480px) {\n  .cat-drawerField-half {\n    grid-column: span 2;\n  }\n}\n\n/* Legacy label style — direct children only, so it never restyles the\n   labels inside the Custom* fields now used in the drawer */\n.cat-drawerField > label {\n  display: block;\n  font-size: 11.5px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  color: #56617a;\n  margin-bottom: 7px;\n}\n\n.cat-drawerInput {\n  width: 100%;\n  padding: 9px 11px;\n  font-size: 13px;\n  border: 1.5px solid #e6e9f0;\n  border-radius: 9px;\n  background: #f8fafc;\n  color: #0f172a;\n  outline: none;\n  transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;\n}\n\n.cat-drawerInput:focus {\n  border-color: var(--cat-accent);\n  background: #ffffff;\n  box-shadow: 0 0 0 3px var(--cui-primary-ring);\n}\n\n/* ---------- custom-chevron select (native <select>, styled trigger) ---------- */\n\n.cat-selectWrap {\n  position: relative;\n}\n\n.cat-drawerSelect {\n  width: 100%;\n  padding: 9px 34px 9px 11px;\n  font-size: 13px;\n  border: 1.5px solid #e6e9f0;\n  border-radius: 9px;\n  background: #f8fafc;\n  color: #0f172a;\n  outline: none;\n  cursor: pointer;\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;\n}\n\n.cat-drawerSelect:focus {\n  border-color: var(--cat-accent);\n  background: #ffffff;\n  box-shadow: 0 0 0 3px var(--cui-primary-ring);\n}\n\n.cat-selectChevron {\n  position: absolute;\n  right: 11px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 15px;\n  height: 15px;\n  color: #94a1b8;\n  pointer-events: none;\n}\n\n.cat-selectWrap:focus-within .cat-selectChevron {\n  color: var(--cat-accent);\n}\n\n/* ---------- toggle field ---------- */\n\n.cat-drawerField-toggle {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.cat-drawerField-toggle label {\n  margin-bottom: 0;\n}\n\n.cat-toggleTrack {\n  position: relative;\n  flex-shrink: 0;\n  width: 42px;\n  height: 24px;\n  border: none;\n  border-radius: 999px;\n  background: #d7dbe3;\n  cursor: pointer;\n  padding: 0;\n  transition: background 0.2s ease;\n}\n\n.cat-toggleTrack-on {\n  background: var(--cat-accent);\n}\n\n.cat-toggleThumb {\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: #fff;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);\n  transition: left 0.2s cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\n.cat-toggleTrack-on .cat-toggleThumb {\n  left: 20px;\n}\n\n/* ---------- radio field ---------- */\n\n.cat-radioGroup {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.cat-radioOption {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  padding: 7px 12px;\n  font-size: 12.5px;\n  font-weight: 500;\n  color: #0f172a;\n  text-transform: none;\n  letter-spacing: normal;\n  background: #f8fafc;\n  border: 1.5px solid #e6e9f0;\n  border-radius: 999px;\n  cursor: pointer;\n  transition: border-color 0.12s ease, background 0.12s ease, color 0.12s ease;\n}\n\n.cat-radioOption:hover {\n  border-color: #c7d2ff;\n}\n\n.cat-radioOption-selected {\n  background: #eef4ff;\n  border-color: var(--cat-accent);\n  color: var(--cat-accent-dark);\n  font-weight: 700;\n}\n\n.cat-radioOption input[type=\"radio\"] {\n  position: absolute;\n  opacity: 0;\n  width: 1px;\n  height: 1px;\n}\n\n.cat-radioDot {\n  width: 13px;\n  height: 13px;\n  border-radius: 50%;\n  border: 1.5px solid #94a1b8;\n  position: relative;\n  flex-shrink: 0;\n}\n\n.cat-radioOption-selected .cat-radioDot {\n  border-color: var(--cat-accent);\n}\n\n.cat-radioOption-selected .cat-radioDot::after {\n  content: \"\";\n  position: absolute;\n  inset: 2px;\n  border-radius: 50%;\n  background: var(--cat-accent);\n}\n\n/* fixed footer — never scrolls, regardless of field count above */\n.cat-drawerFooter {\n  flex-shrink: 0;\n  display: flex;\n  gap: 10px;\n  padding: 14px 18px;\n  border-top: 1px solid #e6e9f0;\n  background: #fff;\n}\n\n.cat-drawerResetBtn {\n  flex: 1;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 10px 14px;\n  font-size: 13px;\n  font-weight: 600;\n  border-radius: 8px;\n    border: 1px solid #fecaca;\n  background: linear-gradient(\n    135deg,\n    #fee2e2 0%,\n    #fecaca 100%\n  );\n\n  color: #b91c1c;\n  cursor: pointer;\n transition:\n    background 0.15s ease,\n    border-color 0.15s ease,\n    box-shadow 0.15s ease,\n    transform 0.1s ease;\n}\n\n.cat-drawerResetBtn:hover {\n  background: linear-gradient(\n    135deg,\n    #fecaca 0%,\n    #fca5a5 100%\n  );\n\n  border-color: #fca5a5;\n\n  box-shadow:\n    0 4px 12px rgba(220, 38, 38, 0.18);\n}\n\n.cat-drawerResetBtn:active {\n  transform: scale(0.98);\n}\n\n.cat-drawerResetBtn:focus-visible {\n  outline: none;\n\n  box-shadow:\n    0 0 0 3px rgba(220, 38, 38, 0.18);\n}\n\n.cat-drawerResetBtn:disabled {\n  background: #f1f5f9;\n  border-color: #e2e8f0;\n  color: #94a3b8;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n.cat-drawerApplyBtn {\n  flex: 2;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n\n  width: 100%;\n  min-height: 38px;\n\n  padding: 8px 16px;\n\n  font-size: 13px;\n  font-weight: 700;\n  line-height: 1;\n\n  border-radius: 8px;\n  border: 1px solid var(--cat-accent);\n\n  background: linear-gradient(\n    135deg,\n    var(--cat-accent) 0%,\n    var(--cat-accent) 50%,\n    var(--cat-accent-dark) 100%\n  );\n\n  color: #ffffff;\n  cursor: pointer;\n\n  box-shadow:\n    0 4px 12px rgba(79, 95, 232, 0.25);\n\n  transition:\n    transform 0.15s ease,\n    box-shadow 0.15s ease,\n    filter 0.15s ease;\n}\n\n.cat-drawerApplyBtn:hover {\n  filter: brightness(1.05);\n\n  box-shadow:\n    0 6px 18px rgba(79, 95, 232, 0.35);\n}\n\n.cat-drawerApplyBtn:active {\n  transform: scale(0.98);\n}\n\n.cat-drawerApplyBtn:focus-visible {\n  outline: none;\n  box-shadow:\n    0 0 0 3px var(--cui-primary-ring);\n}\n\n.cat-drawerApplyBtn:disabled {\n  background: #cbd5e1;\n  border-color: #cbd5e1;\n  box-shadow: none;\n  color: #64748b;\n  cursor: not-allowed;\n}\n\n@media (max-width: 480px) {\n  .cat-drawer {\n    width: 100vw;\n    max-width: 100vw;\n  }\n}\n/* Footer buttons (CustomButton) share the row equally */\n.cat-drawerFooter > .cbtn {\n  flex: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
